import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import logo from "../assets/logo/logo.jpeg";

const footerLinks = {
  "Study Options": [
    { label: "Study Local", href: "/explore-universities?type=Local" },
    { label: "Study Overseas", href: "/explore-universities?type=Overseas" },
    // { label: "Career Path Quiz", href: "#" },
    // { label: "Scholarship Finder", href: "#" },
  ],
  "How It Works": [
    { label: "Create Your Profile", href: "/register" },
    // { label: "University Matching", href: "#pathway" },
    // { label: "Application Support", href: "#process" },
    // { label: "Offer Comparison", href: "#process" },
  ],
  Company: [
    // { label: "About Us", href: "#" },
    { label: "Our Partners", href: "/#partners" },
    // { label: "Blog", href: "#" },
    { label: "Careers", href: "/careers" },
  ],
  Support: [
    { label: "Contact Us", href: "/#contact" },
    // { label: "FAQ", href: "#" },
    { label: "Student Portal", href: "/login" },
    // { label: "Privacy Policy", href: "#" },
  ],
};

const socials = [
  {
    icon: <Instagram className="w-4 h-4" />,
    href: "https://www.instagram.com/scseducation",
    label: "Instagram",
  },
  {
    icon: <Facebook className="w-4 h-4" />,
    href: "https://www.facebook.com/scseducationmy",
    label: "Twitter",
  },
  {
    icon: <Phone className="w-4 h-4" />,
    href: "https://wa.me/601112870256",
    label: "LinkedIn",
  },
  {
    icon: <Mail className="w-4 h-4" />,
    href: "https://mail.google.com/mail/u/0/?fs=1&to=ng.scseducation@gmail.com&tf=cm",
    label: "Email",
  },
];

export function Footer() {
  return (
    <footer className="bg-slate-900 relative overflow-hidden">
      {/* Glow blobs */}
      <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-violet-600/10 blur-3xl pointer-events-none" />
      <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-cyan-500/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Top section */}
        <div className="py-16 grid lg:grid-cols-5 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <a href="#" className="flex items-center gap-2 mb-6">
              <img src={logo} alt="scs education logo" className="w-12 h-12" />
            </a>

            <p
              className="text-[14px] text-slate-400 leading-relaxed mb-8 max-w-xs"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 400 }}
            >
              Malaysia's most student-first education consultancy. We're
              obsessed with getting you into the right university — for free.
            </p>

            {/* Socials */}
            <div className="flex gap-3">
              {socials.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  aria-label={social.label}
                  className="w-9 h-9 rounded-xl bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-violet-600 hover:text-white transition-all duration-200"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Links grid */}
          <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {Object.entries(footerLinks).map(([category, links]) => (
              <div key={category}>
                <p
                  className="text-[11px] text-slate-500 uppercase tracking-widest mb-4"
                  style={{ fontFamily: "Inter, sans-serif", fontWeight: 700 }}
                >
                  {category}
                </p>
                <ul className="flex flex-col gap-3">
                  {links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-[13px] text-slate-400 hover:text-white transition-colors"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          fontWeight: 400,
                        }}
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-[12px] text-slate-600"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 400 }}
          >
            © 2026 SCS Edu Group Sdn Bhd. All rights reserved. Reg. No:
            202101021600(1421900-K)
          </p>
          <div className="flex items-center gap-1">
            <span
              className="text-[12px] text-slate-600"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 400 }}
            >
              Made with 💜 for students everywhere
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
